module.exports = __webpack_public_path__ + "media/images/asterisk-781a0c9314d1a1b133e5c040721a9736.svg";